/**
 * @module  resouces/pdf/templates
 */
module.exports = {
  //Transporte
  getUserDeliveryNoteDefinition: getUserDeliveryNoteDefinition,
  getJoberDeliveryNoteDefinition: getJoberDeliveryNoteDefinition,
  getJobinDeliveryNoteDefinition: getJobinDeliveryNoteDefinition,
  getWarehouseDeliveryNoteDefinition: getWarehouseDeliveryNoteDefinition,
  //Transporte (cambio)
  getUserDeliveryChangeNoteDefinition: getUserDeliveryChangeNoteDefinition,
  getJoberDeliveryChangeNoteDefinition: getJoberDeliveryChangeNoteDefinition,
  getJobinDeliveryChangeNoteDefinition: getJobinDeliveryChangeNoteDefinition,
  //Transporte (devolución)
  getUserDeliveryReturnNoteDefinition: getUserDeliveryReturnNoteDefinition,
  getJoberDeliveryReturnNoteDefinition: getJoberDeliveryReturnNoteDefinition,
  getJobinDeliveryReturnNoteDefinition: getJobinDeliveryReturnNoteDefinition,
  //Precio fijo
  getFixedJobinNoteDefinition: getFixedJobinNoteDefinition,
  getFixedUserNoteDefinition: getFixedUserNoteDefinition,
  getFixedJoberNoteDefinition: getFixedJoberNoteDefinition,
  //Precio fijo (Garantía)
  getFixedUserGuaranteeNoteDefinition: getFixedUserGuaranteeNoteDefinition,
  getFixedJoberGuaranteeNoteDefinition: getFixedJoberGuaranteeNoteDefinition,
  getFixedJobinGuaranteeNoteDefinition: getFixedJobinGuaranteeNoteDefinition
};
/**
 * Jobin styles for all delivery notes
 * @type {Object}
 */

var styles = {
  header: {
    fontSize: 18,
    bold: true,
    margin: [0, 0, 0, 10]
  },
  rightHeader: {
    fontSize: 16,
    bold: true,
    margin: [0, 0, 0, 0],
    alignment: 'right'
  },
  rightSubheader: {
    fontSize: 12,
    margin: [0, 0, 0, 15],
    alignment: 'right'
  },
  headerTable: {
    margin: [0, 5, 0, 15],
    heights: 40
  },
  headerTableBoldNames: {
    margin: [0, 5, 0, 15],
    heights: 40,
    bold: true
  },
  apendixTable: {
    margin: [0, -15, 0, 15],
    heights: 40
  },
  semiTable: {
    margin: [0, 5, 0, 15],
    bold: true,
    layout: {
      vLineColor: '#dddddd'
    }
  },
  tableHeader: {
    bold: true,
    fontSize: 13,
    color: 'black',
    fillColor: '#dddddd'
  },
  tableMiniHeader: {
    bold: true,
    color: 'black',
    fillColor: '#dddddd'
  },
  legal: {
    fontSize: 7
  },
  legalEmphasized: {
    fontSize: 9,
    bold: true
  },
  cif: {
    fontSize: 7,
    alignment: 'center'
  },
  field: {
    bold: false,
    color: '#222222'
  },
  numericField: {
    alignment: 'right'
  },
  boldJobin: {
    bold: true,
    color: '#FA504C'
  },
  boldClient: {
    bold: true,
    color: '#05AFB4'
  },
  boldWorker: {
    bold: true,
    color: '#A64CFA'
  },
  boldBrico: {
    bold: true,
    color: '#C8A046'
  }
};
/**
 * Layout for all tables
 * @type {Object}
 */

var softLinesLayout = {
  vLineColor: '#bbbbbb',
  hLineColor: '#bbbbbb'
};
/**
 * Already formatted pfdMake image to append at the start of the page
 * @type {Object}
 */

var image = {
  width: 100,
  margin: [0, -40, 0, -20],
  image: 'jobinUpperTag'
};
/**
 * Dictionary of images in base64 encoding
 * @type {Object}
 */

var imagesDict = {
  jobinUpperTag: 'data:image/png;base64,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',
  footerImage: 'data:image/png;base64,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',
  headerImage: 'data:image/png;base64,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'
}; // . . . . . legal info . . . .  . .

/**
 * Already formatted table contraining legal conditions
 * @type {Object}
 */

var legalTable = {
  style: 'headerTable',
  layout: softLinesLayout,
  table: {
    widths: ['*'],
    body: [[{
      style: 'tableHeader',
      text: 'Condiciones particulares del contrato de servicio'
    }], [{
      style: 'legal',
      text: ['Este documento establece las condiciones generales aplicables a la contratación de los servicios que ofrece WOLLY CORP, S.L. (en adelante, “', {
        bold: true,
        text: 'WOLLY'
      }, '”) relacionados con la realización y ejecución de obras e instalaciones, así como el transporte de mercancías (en adelante, los “', {
        bold: true,
        text: 'Servicios'
      }, '” o el “', {
        bold: true,
        text: 'Servicio'
      }, '”, indistintamente) que han sido contratados por el Cliente según se indica en el presente', ' Contrato. WOLLY deja expresa constancia que las cláusulas del presente', ' Contrato se consideran condiciones generales de la contratación, dejando', ' expresa y manifiesta constancia el Cliente del conocimiento y aceptación', ' expresa de las mismas y de su incorporación al Contrato.', '\n\n', '1- ', {
        decoration: 'underline',
        text: 'CONDICIONES DEL SERVICIO'
      }, ': el Cliente podrá contratar los Servicios que', ' ofrece WOLLY a través de cualquier medio que éste ofrezca expresamente', ' a tales efectos (a modo de ejemplo ya sea a través de la dirección', ' de email ', {
        decoration: 'underline',
        text: 'hola@wollyhome.com'
      }, ' así como llamando al número de teléfono ', {
        decoration: 'underline',
        text: '91 108 60 67'
      }, '), en los términos y condiciones previamente aceptados por el Cliente. No', ' obstante, determinados Servicios, a discreción de WOLLY, podrán requerir', ' la realización de un presupuesto previo a la contratación del Servicio', ' y sujeto a la aprobación final del Cliente. En el supuesto que el Servicio', ' requerido por el Cliente esté sujeto a la elaboración de un presupuesto', ' previo, el profesional designado por WOLLY se desplazará a la dirección', ' indicada por el Cliente para llevar a cabo una medición específica a partir', ' de la cual podrá generarse el presupuesto en cuestión. La realización de', ' dicha medición tendrá un coste de 29 Euros que, en caso de la contratación', ' del Servicio por parte del Cliente, se descontarán de la factura final.', ' La falta de aceptación del presupuesto significará la no contratación del', ' Servicio y no dará lugar al reintegro del importe previamente abonado en', ' concepto de servicio de medición. Los Servicios que requieran cualquier', ' trabajo adicional y no previsto (a modo de ejemplo, movimiento o desmontaje de muebles, retirada de escombros, etc.) y/o maquinaria especial que fuese', ' requerida expresamente por el Cliente se presupuestará aparte y deberá', ' ser aceptado por el Cliente con carácter previo al inicio del Servicio.', ' Asimismo, el presupuesto relativo al Servicio no incluirá el producto ni', ' el transporte del mismo (entendiéndose como “', {
        bold: true,
        text: 'Producto'
      }, '” todos aquellos bienes', ' muebles que hubieran sido adquiridos por el Cliente en cualquier establecimiento', ' comercial y, en su caso, serán presupuestados aparte. La prestación del', ' Servicio se realizará de lunes a viernes de 8:00 horas y hasta las 18:00', ' horas (festivos NO incluidos). WOLLY en ningún caso se hará responsable', ' de los defectos que pudiera tener el Producto, ni de los defectos de la', ' construcción ni de los vicios ocultos existentes en el lugar de ejecución', ' de los Servicios, ni de las consecuencias que se deriven de los mismos.', ' Corresponderá al Cliente la gestión y obtención, a su costa, de cuantas', ' licencias, permisos y autorizaciones sean necesarios para llevar a cabo', ' el Servicio específico contratado. ', '\n\n', '2- ', {
        decoration: 'underline',
        text: 'TRANSPORTE DEL PRODUCTO'
      }, ': el transporte del Producto no estará incluido', ' en el presupuesto del Servicio y solo estará disponible para los productos', ' adquiridos en cualquier establecimiento comercial. El Servicio de transporte', ' del Producto (en adelante, el “', {
        bold: true,
        text: 'Servicio de Transporte'
      }, '”) estará sujeto a', ' la aceptación final de WOLLY. El Servicio de Transporte se prestará de', ' lunes a viernes de 8:00 horas y hasta las 20.00 horas (festivos NO incluidos)', ' y tendrá cobertura nacional. El Servicio de Transporte no incluye la retirada', ' de muebles ni otros elementos materiales. Tanto el Producto como el Servicio', ' de Transporte deberán haber sido abonados en su totalidad por parte del', ' Cliente con anterioridad a la ejecución del Servicio de Transporte. WOLLY', ' se compromete a la ejecución del Servicio de Transporte, siempre y cuando', ' no hubieran causas de fuerza mayor que lo imposibilitaran, en el plazo', ' máximo de 48 horas desde la fecha que indique el Cliente en el momento', ' de la contratación del Servicio. WOLLY será responsable de cualquier daño', ' o merma que, por cualquier causa, excepto en casos de fuerza mayor, pudiera', ' sufrir el Producto durante su transporte al Cliente. En el supuesto que', ' el Cliente no se encontrara físicamente en el lugar, fecha y hora designada', ' al efecto para la entrega del Producto, deberá acordar expresamente con', ' WOLLY de nuevo el lugar, fecha y hora para la segunda entrega del Producto', ' dentro de un nuevo plazo de 24 - 48 horas siguientes a la fecha de la primera', ' entrega. En el supuesto que el Cliente no se encontrara físicamente en', ' el lugar, fecha y hora designada al efecto para la segunda entrega del', ' Producto, éste será devuelto al Almacén. En dicho caso, el Cliente dispondrá', ' de un plazo de 7 días para desplazarse al Almacén y reclamar el Producto.', ' Transcurrido dicho plazo sin que el Cliente hubiera reclamado el Producto,', ' WOLLY adquirirá la propiedad de la Mercancía, renunciando expresamente', ' el Cliente a la misma, todo ello de conformidad con lo expresamente establecido', ' en el artículo 460 del Código Civil. El Cliente autoriza expresamente a', ' realizar la entrega del Producto a la persona que se encuentre físicamente', ' en el domicilio designado al efecto.', '\n\n', '3- ', {
        decoration: 'underline',
        text: 'SERVICIOS DE URGENCIAS'
      }, ': Adicionalmente, WOLLY gestionará un servicio', ' de urgencias en virtud del cual prestará los Servicios en menos de 3 horas', ' a aquellos clientes que así lo soliciten expresamente. Dicho servicio de', ' urgencias estará sujeto a disponibilidad de profesionales en cada momento', ' concreto y sujeto a la aprobación final de WOLLY. A efectos aclaratorios,', ' el cómputo de las 3 horas contará desde que WOLLY recibe la solicitud del', ' servicio de urgencias hasta que el profesional seleccionado se presente', ' en la dirección indicada expresamente. El servicio de urgencias supondrá', ' un coste adicional para el cliente de conformidad a lo siguiente: (i) un', ' incremento del precio del 50% del PVP del servicio si tienen un PVP de', ' hasta 200€; y (ii) 100€ de incremento fijo por servicios con un coste PVP', ' a partir de los 201€.', '\n\n', '4- ', {
        decoration: 'underline',
        text: 'PAGOS'
      }, ': La totalidad de los Servicios serán abonados en el momento de', ' su contratación por cualquier medio de pago facilitado a tal efecto por', ' WOLLY. Los precios incluyen el IVA y/o cualquier otro impuesto que fuera', ' de aplicación. En el supuesto que el Cliente no abonara el precio de los', ' Servicios contratados en un plazo máximo de 15 días desde la fecha del', ' Contrato, WOLLY podrá resolver el Contrato a su entera discreción. No obstante', ' lo anterior, WOLLY podrá reclamar la indemnización por daños y perjuicios', ' que le corresponda en su caso.  ', '\n\n', '5- ', {
        decoration: 'underline',
        text: 'RECLAMACIONES Y GESTIÓN DE INCIDENCIAS'
      }, ': El Cliente dispondrá de 7 días', ' naturales desde la fecha en la que se realizó el servicio para presentar', ' reclamaciones sobre el Servicio de Transporte o instalaciones llamando', ' directamente al 910601825. Para tramitar la reclamación será obligatorio', ' que el Cliente presente el presente albarán. El Cliente podrá enviar el', ' albarán al e-mail ', {
        decoration: 'underline',
        text: 'atenciónalcliente@wollyhome.com'
      }, ' o mandarla por correo postal a la', ' dirección: Calle del Limonero 22, 28020, Madrid.  En caso de', ' no presentarla o no enviarla en el referido plazo, no se podrá proceder', ' a la tramitación de la reclamación.', '\n\n', '6- ', {
        decoration: 'underline',
        text: 'GARANTIA WOLLY'
      }, ': WOLLY concede al Cliente una garantía de 6 meses a contar desde', ' la fecha de conformidad con la prestación del Servicio recibido. Durante', ' dicho plazo, WOLLY se obliga a reparar los desperfectos y/o daños que hubiera', ' sufrido el Producto. En ningún caso estarán cubiertos por la garantía los', ' desperfectos y/o daños que hubieran sido ocasionados por actuaciones del', ' Cliente. ', '\n\n', '7- ', {
        decoration: 'underline',
        text: 'PROTECCIÓN DE DATOS DE CARACTER PERSONAL'
      }, ': WOLLY se compromete a tratar', ' los datos de carácter personal a los que tiene acceso en virtud de la ejecución', ' del objeto del presente Contrato, de conformidad con la legislación vigente', ' en cada momento y, en su caso, conforme a las indicaciones dadas por el', ' Cliente. Asimismo, WOLLY aplicará todas las medidas de seguridad legalmente', ' requeridas para preservar la integridad, confidencialidad y disponibilidad', ' de datos de carácter personal que resulten de aplicación.', '\n\n', '8- ', {
        decoration: 'underline',
        text: 'JURISDICCIÓN'
      }, '- Para la resolución de cualquier discrepancia en la interpretación', ' o aplicación del presente Contrato, las Partes (entendiéndose éstas como', ' el Cliente y WOLLY), con expresa renuncia al fuero que pueda corresponderles,', ' se someten expresamente a la jurisdicción y competencia de los Juzgados', ' y Tribunales de la ciudad de Madrid.']
    }]]
  }
};
function __getFullPriceBreakdown(priceBreakdown) {
  // . . . . . price breakdown . . . .  . .
  var priceBreakdown__body__ = [];
  for (var i = 0; i < priceBreakdown['name'].length; i++) {
    priceBreakdown__body__.push([{
      style: 'field',
      text: priceBreakdown['name'][i],
      colSpan: 3
    }, '', '', {
      style: ['field', 'numericField'],
      text: priceBreakdown['pricePerUnitNoIVA'][i]
    }, {
      style: ['field', 'numericField'],
      text: priceBreakdown['units'][i]
    }, {
      style: ['field', 'numericField'],
      text: priceBreakdown['totalPriceNoIVA'][i]
    }]);
  }
  return {
    style: 'headerTableBoldNames',
    layout: softLinesLayout,
    table: {
      widths: ['*', '*', '*', '*', '*', '*'],
      body: [[{
        style: 'tableHeader',
        text: 'Desglose del presupuesto',
        colSpan: 6
      }, '', '', '', '', ''], [{
        text: 'Nombre del servicio',
        colSpan: 3
      }, '', '', 'Precio unidad', 'Unidades', 'Precio total']].concat(priceBreakdown__body__, [[{
        border: [false, false, false, false],
        colSpan: 3,
        alignment: 'right',
        text: ''
      }, '', '', {
        style: 'tableMiniHeader',
        text: 'Subtotal',
        colSpan: 2,
        alignment: 'right'
      }, '', {
        style: ['field', 'numericField'],
        text: priceBreakdown['totalNoIVA']
      }], [{
        border: [false, false, false, false],
        colSpan: 3,
        alignment: 'right',
        text: ''
      }, '', '', {
        style: 'tableMiniHeader',
        text: 'IVA (21%)',
        colSpan: 2,
        alignment: 'right'
      }, '', {
        style: ['field', 'numericField'],
        text: priceBreakdown['IVA']
      }], [{
        border: [false, false, false, false],
        colSpan: 3,
        alignment: 'right',
        text: ''
      }, '', '', {
        style: 'tableMiniHeader',
        text: 'Total',
        colSpan: 2,
        alignment: 'right'
      }, '', {
        style: ['field', 'numericField'],
        text: priceBreakdown['total']
      }]])
    }
  };
}
function __getSimplePriceBreakdown(priceBreakdown) {
  var priceBreakdown__body__ = [[{
    style: 'tableHeader',
    text: 'Desglose del presupuesto',
    colSpan: 4
  }, '', '', ''], [{
    text: 'Nombre del servicio',
    colSpan: 3
  }, '', '', 'Unidades']];
  for (var i = 0; i < priceBreakdown['name'].length; i++) {
    priceBreakdown__body__.push([{
      style: 'field',
      text: priceBreakdown['name'][i],
      colSpan: 3
    }, '', '', {
      style: ['field', 'numericField'],
      text: priceBreakdown['units'][i]
    }]);
  }
  return {
    style: 'headerTableBoldNames',
    layout: softLinesLayout,
    table: {
      widths: ['*', '*', '*', '*'],
      body: priceBreakdown__body__
    }
  };
}
function __getSubSummaryTable(title, subsummary) {
  //const resFormat = require('../format');
  var paymentSummary__body__ = [[{
    style: 'tableHeader',
    text: title,
    colSpan: 2
  }, ''], ['Método de pago', 'Importe']];
  for (var method in subsummary) {
    if (method !== 'Total') {
      paymentSummary__body__.push([{
        style: 'field',
        text: method
      }, {
        style: ['field', 'numericField'],
        text: subsummary[method]
      }]);
    }
  }
  paymentSummary__body__.push([{
    style: 'tableMiniHeader',
    text: 'Total'
  }, {
    style: ['field', 'numericField'],
    text: subsummary.Total
  }]);
  return {
    style: 'headerTableBoldNames',
    layout: softLinesLayout,
    table: {
      widths: ['*', '*'],
      body: paymentSummary__body__
    }
  };
}
function __getFixedDetailsTable(verticalDetails, description, verticalIncludes, verticalDoesntInclude, signatureRows) {
  var body, heights;
  if (verticalIncludes && verticalIncludes.length > 0 || verticalDoesntInclude && verticalDoesntInclude.length > 0) {
    heights = ['auto', 'auto', 'auto', 'auto', 100];
    body = [[{
      style: 'tableHeader',
      text: 'Datos del servicio básico',
      colSpan: 4
    }, '', '', ''], ['Servicio', {
      style: 'field',
      text: verticalDetails,
      colSpan: 3
    }, '', ''], ['Descripción', {
      style: 'field',
      text: description,
      colSpan: 3
    }, '', ''], [{
      text: 'El servicio básico incluye',
      colSpan: 2
    }, '', {
      text: ['El servicio básico ', {
        bold: true,
        text: 'NO'
      }, ' incluye'],
      colSpan: 2
    }, ''], [{
      style: 'field',
      ul: JSON.parse(JSON.stringify(verticalIncludes)),
      colSpan: 2
    }, '', {
      style: 'field',
      ul: JSON.parse(JSON.stringify(verticalDoesntInclude)),
      colSpan: 2
    }, '']];
  } else {
    heights = ['auto', 'auto'];
    body = [[{
      style: 'tableHeader',
      text: 'Datos del servicio básico',
      colSpan: 4
    }, '', '', ''], [{
      style: 'field',
      text: description,
      colSpan: 4
    }, '', '']];
  }
  if (signatureRows) {
    body = body.concat(signatureRows);
    heights = heights.concat(signatureRows.map(function () {
      return 50;
    }));
  }
  return {
    style: 'headerTable',
    layout: softLinesLayout,
    table: {
      widths: ['*', '*', '*', '*'],
      heights: heights,
      body: body
    }
  };
}
function __getPaymentSummaryTable(paymentSummary) {
  return {
    columns: [__getSubSummaryTable('Importe pagado', paymentSummary.paid), {
      width: 3,
      text: ''
    }, __getSubSummaryTable('Importe pendiente', paymentSummary.pending)]
  };
}
function __getTransportBasicInfo(transportId, deliveryDate) {
  return {
    style: 'semiTable',
    layout: softLinesLayout,
    table: {
      widths: ['*', '*', '*', '*'],
      body: [['ID Transporte', {
        style: 'field',
        text: transportId
      }, 'Fecha de recogida', {
        style: 'field',
        text: deliveryDate
      }]]
    }
  };
}
function getUserDeliveryNoteDefinition(transportId, description, deliveryDate, priceBreakdown, userName, userPhone, address, distance, weight) {
  // . . . . . client data . . . .  . .
  // . . . . . goods . . . .  . .
  // - -  - - - end -> TABLES - - - - - - 
  // - -  - - - start -> DOCUMENT - - - - - - 
  var dd = {
    content: [
    //Page 1
    image, {
      text: 'Albarán de transporte',
      style: 'rightHeader'
    }, {
      text: 'Copia para el cliente',
      style: ['rightSubheader', 'boldClient']
    }, __getTransportBasicInfo(transportId, deliveryDate), {
      style: 'headerTable',
      layout: softLinesLayout,
      table: {
        widths: ['*', '*', '*', '*'],
        body: [[{
          style: 'tableHeader',
          text: 'Datos del cliente',
          colSpan: 4
        }, '', '', ''], ['Nombre del cliente', {
          style: 'field',
          text: userName,
          colSpan: 3
        }, '', ''], ['Telf del cliente', {
          style: 'field',
          text: userPhone,
          colSpan: 3
        }, '', ''], ['Dirección de entrega', {
          style: 'field',
          text: address,
          colSpan: 3
        }, '', '']]
      }
    }, {
      style: 'headerTable',
      layout: softLinesLayout,
      table: {
        widths: ['*', '*', '*', '*', '*', '*'],
        heights: ['auto', 'auto', 50, 50, 50],
        body: [[{
          style: 'tableHeader',
          text: 'Datos de la mercancía',
          colSpan: 6
        }, '', '', '', '', ''], ['Nº de bultos', '', 'Peso (aprox)', weight + ' kg', 'Distancia', distance + ' km'], [{
          text: 'Observaciones',
          colSpan: 2
        }, '', {
          style: 'field',
          text: description,
          colSpan: 4
        }, '', '', ''], [{
          text: ['Comprobación a la entrega en tienda\n', {
            text: '(Sello Wolly)',
            style: 'boldJobin'
          }],
          colSpan: 2
        }, '', {
          colSpan: 4,
          text: ''
        }, '', '', '']]
      }
    }, __getFullPriceBreakdown(priceBreakdown),
    //__getPaymentSummaryTable(paymentSummary),
    {
      text: 'Wolly Corp, S.L. \n \n B05392014 - Calle Conde de Montornés núm. 1, 46003, Valencia',
      pageBreak: 'after',
      style: 'cif'
    },
    //Page 2
    image, {
      text: 'Albarán de transporte',
      style: 'rightHeader'
    }, {
      text: 'Copia para el cliente',
      style: ['rightSubheader', 'boldClient']
    }, legalTable, {
      text: 'Wolly Corp, S.L. \n \n B05392014 - Calle Conde de Montornés núm. 1, 46003, Valencia',
      style: 'cif'
    }],
    styles: styles,
    defaultStyle: {
      fontSize: 11
    },
    images: {
      jobinUpperTag: imagesDict.jobinUpperTag
    }
  }; // - -  - - - end -> DOCUMENT - - - - - - 

  return dd;
}
function getJoberDeliveryNoteDefinition(transportId, description, deliveryDate, priceBreakdown, userName, userPhone, address, distance, weight) {
  // . . . . . client data . . . .  . 
  // . . . . . goods . . . .  . .
  // - -  - - - end -> TABLES - - - - - - 
  // - -  - - - start -> DOCUMENT - - - - - - 
  var dd = {
    content: [
    //Page 1
    image, {
      text: 'Albarán de transporte',
      style: 'rightHeader'
    }, {
      text: 'Copia para el transportista',
      style: ['rightSubheader', 'boldWorker']
    }, __getTransportBasicInfo(transportId, deliveryDate), {
      style: 'headerTable',
      layout: softLinesLayout,
      table: {
        widths: ['*', '*', '*', '*'],
        body: [[{
          style: 'tableHeader',
          text: 'Datos del cliente',
          colSpan: 4
        }, '', '', ''], ['Nombre del cliente', {
          style: 'field',
          text: userName,
          colSpan: 3
        }, '', ''], ['Telf del cliente', {
          style: 'field',
          text: userPhone
        }, 'Llamar antes', ''], ['Dirección de entrega', {
          style: 'field',
          text: address,
          colSpan: 3
        }, '', '']]
      }
    }, {
      style: 'headerTable',
      layout: softLinesLayout,
      table: {
        widths: ['*', '*', '*', '*', '*', '*'],
        heights: ['auto', 'auto', 50, 50, 50],
        body: [[{
          style: 'tableHeader',
          text: 'Datos de la mercancía',
          colSpan: 6
        }, '', '', '', '', ''], ['Nº de bultos', '', 'Peso (aprox)', weight + ' kg', 'Distancia', distance + ' km'], [{
          text: 'Observaciones',
          colSpan: 2
        }, '', {
          style: 'field',
          text: description,
          colSpan: 4
        }, '', '', ''], [{
          text: ['Comprobación a la entrega en tienda\n', {
            text: '(Sello Wolly)',
            style: 'boldJobin'
          }],
          colSpan: 2
        }, '', {
          colSpan: 4,
          text: ''
        }, '', '', ''], [{
          text: ['Conformidad a la entrega en domicilio\n', {
            text: '(Firma del cliente)',
            style: 'boldClient'
          }],
          colSpan: 2
        }, '', {
          colSpan: 4,
          text: ''
        }, '', '', '']]
      }
    }, __getSimplePriceBreakdown(priceBreakdown), {
      text: 'Wolly Corp, S.L',
      pageBreak: 'after',
      style: 'cif'
    },
    //Page 2
    image, {
      text: 'Albarán de transporte',
      style: 'rightHeader'
    }, {
      text: 'Copia para el transportista',
      style: ['rightSubheader', 'boldWorker']
    }, legalTable, {
      text: 'Wolly Corp, S.L. \n \n B05392014 - Calle Conde de Montornés núm. 1, 46003, Valencia',
      style: 'cif'
    }],
    styles: styles,
    defaultStyle: {
      fontSize: 11
    },
    images: {
      jobinUpperTag: imagesDict.jobinUpperTag
    }
  }; // - -  - - - end -> DOCUMENT - - - - - - 

  return dd;
}
function getJobinDeliveryNoteDefinition(transportId, description, deliveryDate, priceBreakdown, userName, userPhone, address, distance, weight) {
  // . . . . . client data . . . .  . .
  // . . . . . goods . . . .  . .
  // - -  - - - end -> TABLES - - - - - - 
  // - -  - - - start -> DOCUMENT - - - - - - 
  var dd = {
    content: [
    //Page 1
    image, {
      text: 'Albarán de transporte',
      style: 'rightHeader'
    }, {
      text: 'Copia para Wolly',
      style: ['rightSubheader', 'boldJobin']
    }, __getTransportBasicInfo(transportId, deliveryDate), {
      style: 'headerTable',
      layout: softLinesLayout,
      table: {
        widths: ['*', '*', '*', '*'],
        heights: ['auto', 'auto', 'auto', 'auto', 50],
        body: [[{
          style: 'tableHeader',
          text: 'Datos del cliente',
          colSpan: 4
        }, '', '', ''], ['Nombre del cliente', {
          style: 'field',
          text: userName,
          colSpan: 3
        }, '', ''], ['Telf del cliente', {
          style: 'field',
          text: userPhone
        }, 'Llamar antes', ''], ['Dirección de entrega', {
          style: 'field',
          text: address,
          colSpan: 3
        }, '', ''], [['Aceptación de condiciones', {
          text: '(Firma del cliente)',
          style: 'boldClient'
        }], {
          text: '',
          colSpan: 3
        }, '', '']]
      }
    }, {
      style: 'headerTable',
      layout: softLinesLayout,
      table: {
        widths: ['*', '*', '*', '*', '*', '*'],
        heights: ['auto', 'auto', 50, 50, 50],
        body: [[{
          style: 'tableHeader',
          text: 'Datos de la mercancía',
          colSpan: 6
        }, '', '', '', '', ''], ['Nº de bultos', '', 'Peso (aprox)', weight + ' kg', 'Distancia', distance + ' km'], [{
          text: 'Observaciones',
          colSpan: 2
        }, '', {
          style: 'field',
          text: description,
          colSpan: 4
        }, '', '', ''], [{
          text: ['Verificado a la recogida del transportista\n', {
            text: '(Firma / sello del transportista)',
            style: 'boldWorker'
          }],
          colSpan: 2
        }, '', {
          colSpan: 4,
          text: ''
        }, '', '', '']]
      }
    }, __getFullPriceBreakdown(priceBreakdown),
    //__getPaymentSummaryTable(paymentSummary),
    {
      text: 'Wolly Corp, S.L. \n \n B05392014 - Calle Conde de Montornés núm. 1, 46003, Valencia',
      pageBreak: 'after',
      style: 'cif'
    },
    //Page 2
    image, {
      text: 'Albarán de transporte',
      style: 'rightHeader'
    }, {
      text: 'Copia para Wolly',
      style: ['rightSubheader', 'boldJobin']
    }, legalTable, {
      text: 'Wolly Corp, S.L. \n \n B05392014 - Calle Conde de Montornés núm. 1, 46003, Valencia',
      style: 'cif'
    }],
    styles: styles,
    defaultStyle: {
      fontSize: 11
    },
    images: {
      jobinUpperTag: imagesDict.jobinUpperTag
    }
  }; // - -  - - - end -> DOCUMENT - - - - - - 

  return dd;
}
function getWarehouseDeliveryNoteDefinition(transportId, description, deliveryDate, priceBreakdown, userName, userPhone, address, distance, weight) {
  // . . . . . client data . . . .  . .
  // . . . . . goods . . . .  . .
  // - -  - - - end -> TABLES - - - - - - 
  // - -  - - - start -> DOCUMENT - - - - - - 
  var dd = {
    content: [
    //Page 1
    image, {
      text: 'Albarán de transporte',
      style: 'rightHeader'
    }, {
      text: 'Copia para el almacén',
      style: ['rightSubheader', 'boldBrico']
    }, __getTransportBasicInfo(transportId, deliveryDate), {
      style: 'headerTable',
      layout: softLinesLayout,
      table: {
        widths: ['*', '*', '*', '*'],
        body: [[{
          style: 'tableHeader',
          text: 'Datos del cliente',
          colSpan: 4
        }, '', '', ''], ['Nombre del cliente', {
          style: 'field',
          text: userName,
          colSpan: 3
        }, '', '']]
      }
    }, {
      style: 'headerTable',
      layout: softLinesLayout,
      table: {
        widths: ['*', '*', '*', '*', '*', '*'],
        heights: ['auto', 'auto', 50, 50, 50],
        body: [[{
          style: 'tableHeader',
          text: 'Datos de la mercancía',
          colSpan: 6
        }, '', '', '', '', ''], ['Nº de bultos', '', 'Peso (aprox)', weight + ' kg', 'Distancia', distance + ' km'], ['Observaciones', {
          style: 'field',
          text: description,
          colSpan: 5
        }, '', '', '', '']]
      }
    }, __getSimplePriceBreakdown(priceBreakdown), {
      text: 'Wolly Corp, S.L. \n \n B05392014 - Calle Conde de Montornés núm. 1, 46003, Valencia',
      style: 'cif'
    }],
    styles: styles,
    defaultStyle: {
      fontSize: 11
    },
    images: {
      jobinUpperTag: imagesDict.jobinUpperTag
    }
  }; // - -  - - - end -> DOCUMENT - - - - - - 

  return dd;
}
function getUserDeliveryChangeNoteDefinition(transportId, description, deliveryDate, priceBreakdown, userName, userPhone, address, distance, weight) {
  // . . . . . client data . . . .  . .
  // . . . . . goods . . . .  . .
  // - -  - - - end -> TABLES - - - - - - 
  // - -  - - - start -> DOCUMENT - - - - - - 
  var dd = {
    content: [
    //Page 1
    image, {
      text: 'Albarán de transporte',
      style: 'rightHeader'
    }, {
      text: 'Copia para el cliente',
      style: ['rightSubheader', 'boldClient']
    }, __getTransportBasicInfo(transportId, deliveryDate), {
      style: 'headerTable',
      layout: softLinesLayout,
      table: {
        widths: ['*', '*', '*', '*'],
        body: [[{
          style: 'tableHeader',
          text: 'Datos del cliente',
          colSpan: 4
        }, '', '', ''], ['Nombre del cliente', {
          style: 'field',
          text: userName,
          colSpan: 3
        }, '', ''], ['Telf del cliente', {
          style: 'field',
          text: userPhone,
          colSpan: 3
        }, '', ''], ['Dirección de recogida', {
          style: 'field',
          text: address,
          colSpan: 3
        }, '', '']]
      }
    }, {
      style: 'headerTable',
      layout: softLinesLayout,
      table: {
        widths: ['*', '*', '*', '*', '*', '*'],
        heights: ['auto', 'auto', 50, 50, 50],
        body: [[{
          style: 'tableHeader',
          text: 'Datos de la mercancía',
          colSpan: 6
        }, '', '', '', '', ''], ['Nº de bultos', '', 'Peso (aprox)', weight + ' kg', 'Distancia', distance + ' km'], [{
          text: 'Observaciones',
          colSpan: 2
        }, '', {
          style: 'field',
          text: description,
          colSpan: 4
        }, '', '', ''], [{
          text: ['Confirmación de recogida\n', {
            text: '(Firma del transportista)',
            style: 'boldWorker'
          }],
          colSpan: 2
        }, '', {
          colSpan: 4,
          text: ''
        }, '', '', '']]
      }
    }, __getFullPriceBreakdown(priceBreakdown), {
      text: 'Wolly Corp, S.L. \n \n B05392014 - Calle Conde de Montornés núm. 1, 46003, Valencia',
      pageBreak: 'after',
      style: 'cif'
    },
    //Page 2
    image, {
      text: 'Albarán de transporte',
      style: 'rightHeader'
    }, {
      text: 'Copia para el cliente',
      style: ['rightSubheader', 'boldClient']
    }, legalTable, {
      text: 'Wolly Corp, S.L. \n \n B05392014 - Calle Conde de Montornés núm. 1, 46003, Valencia',
      style: 'cif'
    }],
    styles: styles,
    defaultStyle: {
      fontSize: 11
    },
    images: {
      jobinUpperTag: imagesDict.jobinUpperTag
    }
  }; // - -  - - - end -> DOCUMENT - - - - - - 

  return dd;
}
function getJoberDeliveryChangeNoteDefinition(transportId, description, deliveryDate, priceBreakdown, userName, userPhone, address, distance, weight) {
  // . . . . . client data . . . .  . .
  // . . . . . goods . . . .  . .
  // - -  - - - end -> TABLES - - - - - - 
  // - -  - - - start -> DOCUMENT - - - - - - 
  var dd = {
    content: [
    //Page 1
    image, {
      text: 'Albarán de transporte',
      style: 'rightHeader'
    }, {
      text: 'Copia para el transportista',
      style: ['rightSubheader', 'boldWorker']
    }, __getTransportBasicInfo(transportId, deliveryDate), {
      style: 'headerTable',
      layout: softLinesLayout,
      table: {
        widths: ['*', '*', '*', '*'],
        body: [[{
          style: 'tableHeader',
          text: 'Datos del cliente',
          colSpan: 4
        }, '', '', ''], ['Nombre del cliente', {
          style: 'field',
          text: userName,
          colSpan: 3
        }, '', ''], ['Telf del cliente', {
          style: 'field',
          text: userPhone,
          colSpan: 3
        }, '', ''], ['Dirección de recogida', {
          style: 'field',
          text: address,
          colSpan: 3
        }, '', '']]
      }
    }, {
      style: 'headerTable',
      layout: softLinesLayout,
      table: {
        widths: ['*', '*', '*', '*', '*', '*'],
        heights: ['auto', 'auto', 50, 50, 50],
        body: [[{
          style: 'tableHeader',
          text: 'Datos de la mercancía',
          colSpan: 6
        }, '', '', '', '', ''], ['Nº de bultos', '', 'Peso (aprox)', weight + ' kg', 'Distancia', distance + ' km'], [{
          text: 'Observaciones',
          colSpan: 2
        }, '', {
          style: 'field',
          text: description,
          colSpan: 4
        }, '', '', ''], [{
          text: ['Confirmación de recogida\n', {
            text: '(Firma del cliente)',
            style: 'boldClient'
          }],
          colSpan: 2
        }, '', {
          colSpan: 4,
          text: ''
        }, '', '', ''], [{
          text: ['Confirmación de entrega\n', {
            text: '(Sello de Wolly)',
            style: 'boldJobin'
          }],
          colSpan: 2
        }, '', {
          colSpan: 4,
          text: ''
        }, '', '', '']]
      }
    }, __getSimplePriceBreakdown(priceBreakdown), {
      text: 'Wolly Corp, S.L. \n \n B05392014 - Calle Conde de Montornés núm. 1, 46003, Valencia',
      pageBreak: 'after',
      style: 'cif'
    },
    //Page 2
    image, {
      text: 'Albarán de transporte',
      style: 'rightHeader'
    }, {
      text: 'Copia para el transportista',
      style: ['rightSubheader', 'boldWorker']
    }, legalTable, {
      text: 'Wolly Corp, S.L. \n \n B05392014 - Calle Conde de Montornés núm. 1, 46003, Valencia',
      style: 'cif'
    }],
    styles: styles,
    defaultStyle: {
      fontSize: 11
    },
    images: {
      jobinUpperTag: imagesDict.jobinUpperTag
    }
  }; // - -  - - - end -> DOCUMENT - - - - - - 

  return dd;
}
function getJobinDeliveryChangeNoteDefinition(transportId, description, deliveryDate, priceBreakdown, userName, userPhone, address, distance, weight) {
  // . . . . . client data . . . .  . .
  // . . . . . goods . . . .  . .
  // - -  - - - end -> TABLES - - - - - - 
  // - -  - - - start -> DOCUMENT - - - - - - 
  var dd = {
    content: [
    //Page 1
    image, {
      text: 'Albarán de transporte',
      style: 'rightHeader'
    }, {
      text: 'Copia para Wolly',
      style: ['rightSubheader', 'boldJobin']
    }, __getTransportBasicInfo(transportId, deliveryDate), {
      style: 'headerTable',
      layout: softLinesLayout,
      table: {
        widths: ['*', '*', '*', '*'],
        body: [[{
          style: 'tableHeader',
          text: 'Datos del cliente',
          colSpan: 4
        }, '', '', ''], ['Nombre del cliente', {
          style: 'field',
          text: userName,
          colSpan: 3
        }, '', ''], ['Telf del cliente', {
          style: 'field',
          text: userPhone,
          colSpan: 3
        }, '', ''], ['Dirección de recogida', {
          style: 'field',
          text: address,
          colSpan: 3
        }, '', '']]
      }
    }, {
      style: 'headerTable',
      layout: softLinesLayout,
      table: {
        widths: ['*', '*', '*', '*', '*', '*'],
        heights: ['auto', 'auto', 50, 50, 50, 50],
        body: [[{
          style: 'tableHeader',
          text: 'Datos de la mercancía',
          colSpan: 6
        }, '', '', '', '', ''], ['Nº de bultos', '', 'Peso (aprox)', weight + ' kg', 'Distancia', distance + ' km'], [{
          text: 'Observaciones',
          colSpan: 2
        }, '', {
          style: 'field',
          text: description,
          colSpan: 4
        }, '', '', ''], [{
          text: ['Confirmación de recogida\n', {
            text: '(Firma del cliente)',
            style: 'boldClient'
          }],
          colSpan: 2
        }, '', {
          colSpan: 4,
          text: ''
        }, '', '', ''], [{
          text: ['Confirmación de entrega\n', {
            text: '(Firma del transportista)',
            style: 'boldWorker'
          }],
          colSpan: 2
        }, '', {
          colSpan: 4,
          text: ''
        }, '', '', ''], [{
          text: ['Confirmación de servicio\n', {
            text: '(Sello Brico Depot)',
            style: 'boldBrico'
          }],
          colSpan: 2
        }, '', {
          colSpan: 4,
          text: ''
        }, '', '', '']]
      }
    }, __getFullPriceBreakdown(priceBreakdown), {
      text: 'Wolly Corp, S.L. \n \n B05392014 - Calle Conde de Montornés núm. 1, 46003, Valencia',
      pageBreak: 'after',
      style: 'cif'
    },
    //Page 2
    image, {
      text: 'Albarán de transporte',
      style: 'rightHeader'
    }, {
      text: 'Copia para Wolly',
      style: ['rightSubheader', 'boldJobin']
    }, legalTable, {
      text: 'Wolly Corp, S.L. \n \n B05392014 - Calle Conde de Montornés núm. 1, 46003, Valencia',
      style: 'cif'
    }],
    styles: styles,
    defaultStyle: {
      fontSize: 11
    },
    images: {
      jobinUpperTag: imagesDict.jobinUpperTag
    }
  }; // - -  - - - end -> DOCUMENT - - - - - - 

  return dd;
}
function getUserDeliveryReturnNoteDefinition(transportId, description, deliveryDate, priceBreakdown, userName, userPhone, address, distance, weight) {
  //Actualmente los albaranes de cambio y devolucion son iguales.
  return getUserDeliveryChangeNoteDefinition(transportId, description, deliveryDate, priceBreakdown, userName, userPhone, address, distance, weight);
}
function getJoberDeliveryReturnNoteDefinition(transportId, description, deliveryDate, priceBreakdown, userName, userPhone, address, distance, weight) {
  //Actualmente los albaranes de cambio y devolucion son iguales.
  return getJoberDeliveryChangeNoteDefinition(transportId, description, deliveryDate, priceBreakdown, userName, userPhone, address, distance, weight);
}
function getJobinDeliveryReturnNoteDefinition(transportId, description, deliveryDate, priceBreakdown, userName, userPhone, address, distance, weight) {
  //Actualmente los albaranes de cambio y devolucion son iguales.
  return getJobinDeliveryChangeNoteDefinition(transportId, description, deliveryDate, priceBreakdown, userName, userPhone, address, distance, weight);
}
function getFixedUserGuaranteeNoteDefinition(fixedId, oldFixedId, createdAt, userName, userPhone, address, description) {
  //let smallBarCode = __getSmallBarcode(fixedId);
  // - -  - - - start -> TABLES - - - - - - 
  // . . . . . basic info . . . .  . .
  // . . . . . client data . . . .  . .
  // . . . . . fixed details . . . .  . .
  // . . . . . legal apendix . . . .  . .
  // - -  - - - end -> TABLES - - - - - - 
  // - -  - - - start -> DOCUMENT - - - - - - 
  var dd = {
    content: [
    //Page 1
    image, {
      text: 'Albarán',
      style: 'rightHeader'
    }, {
      text: 'Copia para el cliente',
      style: ['rightSubheader', 'boldClient']
    }, {
      style: 'semiTable',
      layout: softLinesLayout,
      table: {
        widths: ['*', '*', '*', '*'],
        body: [['ID Servicio', {
          style: 'field',
          text: fixedId
        }, 'Fecha de contratación', {
          style: 'field',
          text: createdAt
        }], ['ID Servicio reclamado', {
          style: 'field',
          text: oldFixedId
        }, {
          text: '',
          border: [false, false, false, false]
        }, {
          text: '',
          border: [false, false, false, false]
        }]]
      }
    }, {
      style: 'headerTable',
      layout: softLinesLayout,
      table: {
        widths: ['*', '*', '*', '*'],
        body: [[{
          style: 'tableHeader',
          text: 'Datos del cliente',
          colSpan: 4
        }, '', '', ''], ['Nombre del cliente', {
          style: 'field',
          text: userName
        }, 'Telf del cliente', {
          style: 'field',
          text: userPhone
        }], ['Dirección del servicio', {
          style: 'field',
          text: address,
          colSpan: 3
        }, '', '']]
      }
    }, {
      style: 'headerTable',
      layout: softLinesLayout,
      table: {
        widths: ['*', '*', '*', '*'],
        heights: ['auto', 100, 50],
        body: [[{
          style: 'tableHeader',
          text: 'Datos del servicio',
          colSpan: 4
        }, '', '', ''], ['Descripción', {
          style: 'field',
          text: description,
          colSpan: 3
        }, '', ''], [{
          text: ['Comprobación del proveedor\n', {
            text: '(Sello Wolly)',
            style: 'boldJobin'
          }]
        }, {
          colSpan: 3,
          text: ''
        }, '', '']]
      }
    }, {
      text: 'Wolly Corp, S.L. \n \n B05392014 - Calle Conde de Montornés núm. 1, 46003, Valencia',
      pageBreak: 'after',
      style: 'cif'
    },
    //Page 2
    image, {
      text: 'Albarán',
      style: 'rightHeader'
    }, {
      text: 'Copia para el cliente',
      style: ['rightSubheader', 'boldClient']
    }, legalTable, JSON.parse(JSON.stringify({
      style: 'apendixTable',
      layout: softLinesLayout,
      table: {
        widths: ['*', '*', '*', '*'],
        heights: [50],
        body: [[{
          text: ['Comprobación del proveedor\n', {
            text: '(Sello Wolly)',
            style: 'boldJobin'
          }],
          border: [true, false, true, true]
        }, {
          colSpan: 3,
          text: '',
          border: [true, false, true, true]
        }, '', '']]
      }
    })), {
      text: 'Wolly Corp, S.L. \n \n B05392014 - Calle Conde de Montornés núm. 1, 46003, Valencia',
      style: 'cif'
    }],
    styles: styles,
    defaultStyle: {
      fontSize: 11
    },
    images: {
      jobinUpperTag: imagesDict.jobinUpperTag
    }
  }; // - -  - - - end -> DOCUMENT - - - - - - 

  return dd;
}
function getFixedJobinGuaranteeNoteDefinition(fixedId, oldFixedId, createdAt, userName, userPhone, address, description) {
  //let smallBarCode = __getSmallBarcode(fixedId);
  // - -  - - - start -> TABLES - - - - - - 
  // . . . . . basic info . . . .  . .
  // . . . . . client data . . . .  . .
  // . . . . . fixed details . . . .  . .
  // . . . . . legal apendix . . . .  . .
  // - -  - - - end -> TABLES - - - - - - 
  // - -  - - - start -> DOCUMENT - - - - - - 
  var dd = {
    content: [
    //Page 1
    image, {
      text: 'Albarán',
      style: 'rightHeader'
    }, {
      text: 'Copia para Wolly',
      style: ['rightSubheader', 'boldJobin']
    }, {
      style: 'semiTable',
      layout: softLinesLayout,
      table: {
        widths: ['*', '*', '*', '*'],
        body: [['ID Servicio', {
          style: 'field',
          text: fixedId
        }, 'Fecha de contratación', {
          style: 'field',
          text: createdAt
        }], ['ID Servicio reclamado', {
          style: 'field',
          text: oldFixedId
        }, {
          text: '',
          border: [false, false, false, false]
        }, {
          text: '',
          border: [false, false, false, false]
        }]]
      }
    }, {
      style: 'headerTable',
      layout: softLinesLayout,
      table: {
        widths: ['*', '*', '*', '*'],
        body: [[{
          style: 'tableHeader',
          text: 'Datos del cliente',
          colSpan: 4
        }, '', '', ''], ['Nombre del cliente', {
          style: 'field',
          text: userName
        }, 'Telf del cliente', {
          style: 'field',
          text: userPhone
        }], ['Dirección del servicio', {
          style: 'field',
          text: address,
          colSpan: 3
        }, '', '']]
      }
    }, {
      style: 'headerTable',
      layout: softLinesLayout,
      table: {
        widths: ['*', '*', '*', '*'],
        heights: ['auto', 100, 50],
        body: [[{
          style: 'tableHeader',
          text: 'Datos del servicio',
          colSpan: 4
        }, '', '', ''], ['Descripción', {
          style: 'field',
          text: description,
          colSpan: 3
        }, '', ''], [{
          text: ['Conformidad del cliente\n', {
            text: '(Firma del cliente)',
            style: 'boldClient'
          }]
        }, {
          colSpan: 3,
          text: ''
        }, '', '']]
      }
    }, {
      text: 'Wolly Corp, S.L. \n \n B05392014 - Calle Conde de Montornés núm. 1, 46003, Valencia',
      pageBreak: 'after',
      style: 'cif'
    },
    //Page 2
    image, {
      text: 'Albarán',
      style: 'rightHeader'
    }, {
      text: 'Copia para Wolly',
      style: ['rightSubheader', 'boldJobin']
    }, legalTable, JSON.parse(JSON.stringify({
      style: 'apendixTable',
      layout: softLinesLayout,
      table: {
        widths: ['*', '*', '*', '*'],
        heights: [50],
        body: [[{
          text: ['Conformidad del cliente\n', {
            text: '(Firma del cliente)',
            style: 'boldClient'
          }],
          border: [true, false, true, true]
        }, {
          colSpan: 3,
          text: '',
          border: [true, false, true, true]
        }, '', '']]
      }
    })), {
      text: 'Wolly Corp, S.L. \n \n B05392014 - Calle Conde de Montornés núm. 1, 46003, Valencia',
      style: 'cif'
    }],
    styles: styles,
    defaultStyle: {
      fontSize: 11
    },
    images: {
      jobinUpperTag: imagesDict.jobinUpperTag
    }
  }; // - -  - - - end -> DOCUMENT - - - - - - 

  return dd;
}
function getFixedJoberGuaranteeNoteDefinition(fixedId, oldFixedId, createdAt, userName, userPhone, address, description) {
  //let smallBarCode = __getSmallBarcode(fixedId);
  // - -  - - - start -> TABLES - - - - - - 
  // . . . . . basic info . . . .  . .
  // . . . . . client data . . . .  . .
  // . . . . . fixed details . . . .  . .
  // . . . . . legal apendix . . . .  . .
  // - -  - - - end -> TABLES - - - - - - 
  // - -  - - - start -> DOCUMENT - - - - - - 
  var dd = {
    content: [
    //Page 1
    image, {
      text: 'Albarán',
      style: 'rightHeader'
    }, {
      text: 'Conformidad del cliente',
      style: ['rightSubheader', 'boldWorker']
    }, {
      style: 'semiTable',
      layout: softLinesLayout,
      table: {
        widths: ['*', '*', '*', '*'],
        body: [['ID Servicio', {
          style: 'field',
          text: fixedId
        }, 'Fecha de contratación', {
          style: 'field',
          text: createdAt
        }], ['ID Servicio reclamado', {
          style: 'field',
          text: oldFixedId
        }, {
          text: '',
          border: [false, false, false, false]
        }, {
          text: '',
          border: [false, false, false, false]
        }]]
      }
    }, {
      style: 'headerTable',
      layout: softLinesLayout,
      table: {
        widths: ['*', '*', '*', '*'],
        body: [[{
          style: 'tableHeader',
          text: 'Datos del cliente',
          colSpan: 4
        }, '', '', ''], ['Nombre del cliente', {
          style: 'field',
          text: userName
        }, 'Telf del cliente', {
          style: 'field',
          text: userPhone
        }], ['Dirección del servicio', {
          style: 'field',
          text: address,
          colSpan: 3
        }, '', '']]
      }
    }, {
      style: 'headerTable',
      layout: softLinesLayout,
      table: {
        widths: ['*', '*', '*', '*'],
        heights: ['auto', 100, 50],
        body: [[{
          style: 'tableHeader',
          text: 'Datos del servicio',
          colSpan: 4
        }, '', '', ''], ['Descripción', {
          style: 'field',
          text: description,
          colSpan: 3
        }, '', ''], [{
          text: ['Conformidad del cliente\n', {
            text: '(Firma del cliente)',
            style: 'boldClient'
          }]
        }, {
          colSpan: 3,
          text: ''
        }, '', '']]
      }
    }, {
      text: 'Wolly Corp, S.L. \n \n B05392014 - Calle Conde de Montornés núm. 1, 46003, Valencia',
      pageBreak: 'after',
      style: 'cif'
    },
    //Page 2
    image, {
      text: 'Albarán',
      style: 'rightHeader'
    }, {
      text: 'Copia para Wolly',
      style: ['rightSubheader', 'boldJobin']
    }, legalTable, JSON.parse(JSON.stringify({
      style: 'apendixTable',
      layout: softLinesLayout,
      table: {
        widths: ['*', '*', '*', '*'],
        heights: [50],
        body: [[{
          text: ['Conformidad del cliente\n', {
            text: '(Firma del cliente)',
            style: 'boldClient'
          }],
          border: [true, false, true, true]
        }, {
          colSpan: 3,
          text: '',
          border: [true, false, true, true]
        }, '', '']]
      }
    })), {
      text: 'Wolly Corp, S.L. \n \n B05392014 - Calle Conde de Montornés núm. 1, 46003, Valencia',
      style: 'cif'
    }],
    styles: styles,
    defaultStyle: {
      fontSize: 11
    },
    images: {
      jobinUpperTag: imagesDict.jobinUpperTag
    }
  }; // - -  - - - end -> DOCUMENT - - - - - - 

  return dd;
}
function getFixedJobinNoteDefinition(fixedId, createdAt, priceBreakdown, userName, userPhone, address, verticalDetails, description, verticalIncludes, verticalDoesntInclude) {
  //let smallBarCode = __getSmallBarcode(fixedId);
  // - -  - - - start -> TABLES - - - - - - 
  // . . . . . basic info . . . .  . .
  // . . . . . client data . . . .  . .
  // . . . . . fixed details . . . .  . .
  var fixedDetailsTable_jobin = __getFixedDetailsTable(verticalDetails, description, verticalIncludes, verticalDoesntInclude, [[{
    text: ['Conformidad del cliente\n', {
      text: '(Firma del cliente)',
      style: 'boldClient'
    }]
  }, {
    colSpan: 3,
    text: ''
  }, '', '']]); // . . . . . legal apendix . . . .  . .

  // - -  - - - end -> TABLES - - - - - - 
  // - -  - - - start -> DOCUMENT - - - - - - 
  var dd = {
    content: [
    //Page 1
    image, {
      text: 'Albarán',
      style: 'rightHeader'
    }, {
      text: 'Copia para Wolly',
      style: ['rightSubheader', 'boldJobin']
    }, {
      style: 'semiTable',
      layout: softLinesLayout,
      table: {
        widths: ['*', '*', '*', '*'],
        body: [['ID Servicio', {
          style: 'field',
          text: fixedId
        }, 'Fecha de contratación', {
          style: 'field',
          text: createdAt
        }]]
      }
    }, {
      style: 'headerTable',
      layout: softLinesLayout,
      table: {
        widths: ['*', '*', '*', '*'],
        body: [[{
          style: 'tableHeader',
          text: 'Datos del cliente',
          colSpan: 4
        }, '', '', ''], ['Nombre del cliente', {
          style: 'field',
          text: userName
        }, 'Telf del cliente', {
          style: 'field',
          text: userPhone
        }], ['Dirección del servicio', {
          style: 'field',
          text: address,
          colSpan: 3
        }, '', '']]
      }
    }, __getFullPriceBreakdown(priceBreakdown), fixedDetailsTable_jobin,
    //__getPaymentSummaryTable(paymentSummary),
    {
      text: 'Wolly Corp, S.L. \n \n B05392014 - Calle Conde de Montornés núm. 1, 46003, Valencia',
      pageBreak: 'after',
      style: 'cif'
    },
    //Page 2
    image, {
      text: 'Albarán',
      style: 'rightHeader'
    }, {
      text: 'Copia para Wolly',
      style: ['rightSubheader', 'boldJobin']
    }, legalTable, JSON.parse(JSON.stringify({
      style: 'apendixTable',
      layout: softLinesLayout,
      table: {
        widths: ['*', '*', '*', '*'],
        heights: [50],
        body: [[{
          text: ['Conformidad del cliente\n', {
            text: '(Firma del cliente)',
            style: 'boldClient'
          }],
          border: [true, false, true, true]
        }, {
          colSpan: 3,
          text: '',
          border: [true, false, true, true]
        }, '', '']]
      }
    })), {
      text: 'Wolly Corp, S.L. \n \n B05392014 - Calle Conde de Montornés núm. 1, 46003, Valencia',
      style: 'cif'
    }],
    styles: styles,
    defaultStyle: {
      fontSize: 11
    },
    images: {
      jobinUpperTag: imagesDict.jobinUpperTag
    }
  }; // - -  - - - end -> DOCUMENT - - - - - - 

  return dd;
}
function getFixedUserNoteDefinition(fixedId, createdAt, priceBreakdown, userName, userPhone, address, verticalDetails, description, verticalIncludes, verticalDoesntInclude) {
  //let smallBarCode = __getSmallBarcode(fixedId);
  // - -  - - - start -> TABLES - - - - - - 
  // . . . . . basic info . . . .  . .
  // . . . . . client data . . . .  . .
  // . . . . . fixed details . . . .  . .
  var fixedDetailsTable_client = __getFixedDetailsTable(verticalDetails, description, verticalIncludes, verticalDoesntInclude); // - -  - - - end -> TABLES - - - - - - 
  // - -  - - - start -> DOCUMENT - - - - - - 

  var dd = {
    content: [
    //Page 1
    image, {
      text: 'Servicio contratado',
      style: 'rightHeader'
    }, {
      text: 'Copia para el cliente',
      style: ['rightSubheader', 'boldClient']
    }, {
      style: 'semiTable',
      layout: softLinesLayout,
      table: {
        widths: ['*', '*', '*', '*'],
        body: [['ID Presupuesto', {
          style: 'field',
          text: fixedId
        }, 'Fecha de emisión', {
          style: 'field',
          text: createdAt
        }]]
      }
    }, {
      style: 'headerTable',
      layout: softLinesLayout,
      table: {
        widths: ['*', '*', '*', '*'],
        body: [[{
          style: 'tableHeader',
          text: 'Datos del cliente',
          colSpan: 4
        }, '', '', ''], ['Nombre del cliente', {
          style: 'field',
          text: userName
        }, 'Telf del cliente', {
          style: 'field',
          text: userPhone
        }], ['Dirección del servicio', {
          style: 'field',
          text: address,
          colSpan: 3
        }, '', '']]
      }
    }, __getFullPriceBreakdown(priceBreakdown), fixedDetailsTable_client,
    //__getPaymentSummaryTable(paymentSummary),
    {
      text: 'Wolly Corp, S.L. \n \n B05392014 - Calle Conde de Montornés núm. 1, 46003, Valencia',
      pageBreak: 'after',
      style: 'cif'
    },
    //Page 2
    image, {
      text: 'Servicio contratado',
      style: 'rightHeader'
    }, {
      text: 'Copia para el cliente',
      style: ['rightSubheader', 'boldClient']
    }, legalTable, {
      text: 'Wolly Corp, S.L. \n \n B05392014 - Calle Conde de Montornés núm. 1, 46003, Valencia',
      style: 'cif'
    }],
    styles: styles,
    defaultStyle: {
      fontSize: 11
    },
    images: {
      jobinUpperTag: imagesDict.jobinUpperTag
    }
  }; // - -  - - - end -> DOCUMENT - - - - - - 

  return dd;
}
function getFixedJoberNoteDefinition(fixedId, createdAt, priceBreakdown, userName, userPhone, address, verticalDetails, description, verticalIncludes, verticalDoesntInclude, signature) {
  // - -  - - - start -> TABLES - - - - - - 
  // . . . . . basic info . . . .  . .
  // . . . . . client data . . . .  . .
  // . . . . . fixed details . . . .  . .
  var fixedDetailsTable_worker = __getFixedDetailsTable(verticalDetails, description, verticalIncludes, verticalDoesntInclude, [[{
    text: ['Conformidad del cliente\n', {
      text: '(Firma del cliente)',
      style: 'boldClient'
    }]
  }, signature ? {
    colSpan: 3,
    fit: [320, 180],
    image: signature
  } : {
    colSpan: 3,
    text: ''
  }, '', '']]); // - -  - - - end -> TABLES - - - - - - 
  // - -  - - - start -> DOCUMENT - - - - - - 

  var dd = {
    content: [
    //Page 1
    image, {
      text: 'Albarán',
      style: 'rightHeader'
    }, {
      text: 'Conformidad del cliente',
      style: ['rightSubheader', 'boldWorker']
    }, {
      style: 'semiTable',
      layout: softLinesLayout,
      table: {
        widths: ['*', '*', '*', '*'],
        body: [['ID Servicio', {
          style: 'field',
          text: fixedId
        }, 'Fecha de contratación', {
          style: 'field',
          text: createdAt
        }]]
      }
    }, {
      style: 'headerTable',
      layout: softLinesLayout,
      table: {
        widths: ['*', '*', '*', '*'],
        body: [[{
          style: 'tableHeader',
          text: 'Datos del cliente',
          colSpan: 4
        }, '', '', ''], ['Nombre del cliente', {
          style: 'field',
          text: userName
        }, 'Telf del cliente', {
          style: 'field',
          text: userPhone
        }], ['Dirección del servicio', {
          style: 'field',
          text: address,
          colSpan: 3
        }, '', '']]
      }
    }, __getSimplePriceBreakdown(priceBreakdown), fixedDetailsTable_worker, {
      text: 'Wolly Corp, S.L. \n \n B05392014 - Calle Conde de Montornés núm. 1, 46003, Valencia',
      style: 'cif'
    }],
    styles: styles,
    defaultStyle: {
      fontSize: 11
    },
    images: {
      jobinUpperTag: imagesDict.jobinUpperTag
    }
  }; // - -  - - - end -> DOCUMENT - - - - - - 

  return dd;
}